module.exports = __webpack_public_path__ + "img/banner-imgMob4x.png";